import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import * as actions from '../../actions/index';

import './UnityDisplay.css';

class UnityDisplay extends React.Component {
  componentDidMount() {
    this.props.setUnityDisplay(true);
  }

  componentWillUnmount() {
    this.props.setUnityDisplay(false);
  }

  render() {
    return (
      <section className={`unityDisplay ${this.props.data.style}`}>
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setOverlay: (bool) => {
      dispatch(actions.setOverlay(bool));
    },
    setUnityDisplay: (bool) => {
      dispatch(actions.setUnityDisplay(bool));
    },
    callUnityScene: (num) => {
      dispatch(actions.callUnityScene(num));
    },
  };
}

function mapStateToProps(state) {
  return {
    overlay: state.navigation.overlay,
    currentSection: state.navigation.currentSection,
  };
}

UnityDisplay.propTypes = {
  data: propTypes.object.isRequired,
  overlay: propTypes.bool.isRequired,
  setOverlay: propTypes.func.isRequired,
  callUnityScene: propTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnityDisplay);




// WEBPACK FOOTER //
// ./src/components/UnityDisplay/UnityDisplay.js